import React from 'react'
import ReactDOMServer from 'react-dom/server'

export const customHeaderTemplate = (param: { tooltip: string }): string => {
  // https://www.ag-grid.com/javascript-grid-column-header/#header-templates

  return textHead + (param.tooltip ? helpIcon() : '') + textFoot
}

const helpIcon = () => {
  return ReactDOMServer.renderToString(
    <span
      className="ag-header-cell-label material-icons"
      style={{
        fontSize: '1rem',
        color: '#888',
        marginLeft: 3,
        maxWidth: '1rem',
      }}
    >
      help_outline
    </span>
  )
}

const textHead =
  '<div class="ag-cell-label-container" role="presentation">' +
  '  <span data-ref="eMenu" class="ag-header-icon ag-header-cell-menu-button" aria-hidden="true"></span>' +
  '  <span data-ref="eFilterButton" class="ag-header-icon ag-header-cell-filter-button" aria-hidden="true"></span>' +
  '  <div data-ref="eLabel" class="ag-header-cell-label" role="presentation">' +
  '    <span data-ref="eText" class="ag-header-cell-text"></span>'

const textFoot =
  '    <span data-ref="eFilter" class="ag-header-icon ag-header-label-icon ag-filter-icon" aria-hidden="true"></span>' +
  '    <ag-sort-indicator data-ref="eSortIndicator"></ag-sort-indicator>' +
  '  </div>' +
  '</div>'
